import { SHOW_NOTIFICATION } from './NotificationActionType'

export function showNotification(isShown, message, type, autoHideDuration) {
  return {
    type: SHOW_NOTIFICATION,
    payload: {
      isShown,
      message,
      type,
      autoHideDuration,
    },
  }
}
